module.exports = __webpack_public_path__ + "img/高效传输.6d61f4a3.png";